import React from 'react'

function Following() {
  return (
    <div>
       {/* Accounts the user is following */}
    </div>
  )
}

export default Following
